module.exports = __webpack_public_path__ + "img/translator__ru-ch.72d6286.svg";